/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const forgotPasswordRequestSchema = z.object({
  email: z.coerce.string(),
});
